module.exports = __webpack_public_path__ + "img/03.cb3978a6.png";